import { IDecodedJwt } from '../constants/auth';

export function parseJWT(jwt: string): IDecodedJwt {
  const parts = jwt.split('.');
  if (parts.length < 3) {
    throw new Error('Invalid JWT format. It should have three parts separated by dots.');
  }
  const header = JSON.parse(atob(parts[0]));
  const payload = parts[1].length === 0 ? null : JSON.parse(atob(parts[1]));
  return { header, payload, signature: parts[2] } as IDecodedJwt;
}
